export default __webpack_public_path__ + "static/media/instagram.d63f2d89.svg";